export class Stat {
  public endTime: number
  public contentName: string
  public deviceName: string
  public startTime: number
  public totalSize: number
  public transferedRate: number
  public transferedSize: number
}
